module.exports = __webpack_public_path__ + "img/syukyaku-top-001.ac2383a5.jpg";